export const PRESENTATION_POSITION_PIP = 'PIP';
export const PRESENTATION_POSITION_SBS = 'SBS';
export const PRESENTATION_POSITION_SINGLE = 'Single';
